import util from '@/common/util';
import { defaultCurrencyCode, defaultCurrencySymbol } from './constant.js';
const localLngKey = 'chimetrans';
const localCurrencyKey = 'chime_currency';
const localCurrencySymbol = 'chime_currency_symbol';

const localLanguage = {
    get() {
        return util.getCookie(localLngKey);
    },
    set(lang) {
        util.setCookie(localLngKey, lang);
    }
};

const localCurrency = {
    get() {
        return util.getCookie(localCurrencyKey);
    },
    getSymbol() {
        let currencySymbol = util.getCookie(localCurrencySymbol);
        return (currencySymbol && decodeURIComponent(currencySymbol)) || '$';
    },
    set({ abbr, symbol }) {
        util.setCookie(localCurrencyKey, abbr);
        util.setCookie(
            localCurrencySymbol,
            symbol && encodeURIComponent(symbol)
        );
    },
    reset() {
        util.setCookie(localCurrencyKey, defaultCurrencyCode);
        util.setCookie(
            localCurrencySymbol,
            encodeURIComponent(defaultCurrencySymbol)
        );
    }
};
window.localCurrency = localCurrency;

export { localLanguage, localCurrency };
